import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, NodePOSTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import SendBulk from "./Email";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [Details, setDetails] = React.useState(JSON.parse(FetchData.meta.details))

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const type_array = {
    "korean": "Korean",
    "nasu": "nasu",
    "sakhaadhikrit": "sakhaadhikrit",
  }

  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "details": JSON.stringify(Details),
      }
    }


    AdsPUTApi(data, slugs.db_slug_nagarpalika, ID)
      .then((res) => {
        setReload(false)
        setAlertShow(true)
        setAlertcomp(`${Title} edited Successfully`)
      }).catch(err => {
        setReload(false)
        setAlertShow(true)
        setAlertcomp(err.response.data.message)
      })
  }

  const [IncludeName, setIncludeName] = React.useState("")
  const [EmailSubject, setEmailSubject] = React.useState("")
  const [EmailContent, setEmailContent] = React.useState("")
  const [AddNewCourse, setAddNewCourse] = React.useState(false)
  const [serachCourseName, setSearchCourseName] = React.useState("")
  const [CourseArray, setCourseArray] = React.useState([])
  const [CourseArray1, setCourseArray1] = React.useState([])
  const [CourseDeleteIndex, setCourseIndex] = React.useState("")
  const [CourseDeleteModal, setCourseDeleteModal] = React.useState(false)
  const [EditCourseGroup, setEditCourseGroup] = React.useState(false)
  const [CourseGroupChoosen, setCourseGroupChoosen] = React.useState("All")
  const [ShowCourseGroupList, setShowCourseGroupList] = React.useState(true)
  const [ImportData, setImportData] = React.useState([])
  const [toStudentModel, setToStudentModal] = React.useState(false)
  const [ChangeToStudentModal, setChangeToStudentModal] = React.useState(false)
  const [ChangeToStudentBatchModal, setChangeToStudentBatchModal] = React.useState(false)
  const [counter, setCounter] = React.useState(0)
  const fileRefSingle = React.createRef();
  const date = new Date();
  const SendEmail = (email, content) => {
    NodePOSTApi({
      email: email,
      subject: EmailSubject,
      body: content
    }, "send_email")
      .then(res => {
        setCounter(counter + 1)
        console.log(res)
        // alert("EMail sent successfully")
      })
      .catch(e => {
        console.log(e)

        // alert("email error")
      })
      .finally(() => {
        setReload(false)

      })

  }
  const UploadDetails = () => {

  }

  const [file, setFile] = React.useState(null);
  const fileReader = new FileReader();

  const handleOnChange = (e) => {
    // setFile(e.target.files[0]);
    e.preventDefault();
    const file = e.target.files[0]
    if (file) {
      fileReader.onload = function (event) {
        const csvOutput = event.target.result;
        const jsonData = convertCSVToJson(csvOutput);

        console.log(jsonData)
        var newData = []
        // setImportData(jsonData)
        var newData = []
        for (let i = 0; i < jsonData.length; i++) {
          const jsonDatai = jsonData[i]
          console.log(Details, jsonDatai)
          const searchEmail = Object.values(Details).filter(a => a.Email == jsonDatai["Email"])
          console.log(jsonDatai, "asddasd", searchEmail.length)
          const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
          function validateEmail(email) {
            return emailRegex.test(email);
          }
          const isValidEmail = validateEmail(jsonDatai["Email"]);
          var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          var passwordLength = 12;
          var password = "";
          for (let l = 0; l <= passwordLength; l++) {
            var randomNumber = Math.floor(Math.random() * chars.length);
            password += chars.substring(randomNumber, randomNumber + 1);
          }
          if (isValidEmail)
            if (searchEmail.length == 0)
              newData.push(jsonDatai)
        }
        setImportData(newData)
      };
      fileReader.readAsText(file);
    };
  }

  const convertCSVToJson = (csvData) => {
    const lines = csvData.split("\n");
    console.log(lines)
    const headers = lines[0].replace("\r", "").split(",");
    const result = [];
    // console.log(headers, lines[0])
    for (let i = 1; i < lines.length; i++) {
      var obj = {};
      const currentLine = lines[i].replace("\r", "").split(",");
      // console.log(currentLine)
      for (let j = 0; j < headers.length; j++) {
        // obj[headers[j].trim()] = currentLine[j].trim();
        console.log(headers[j])
        var key = headers[j]
        obj = {
          ...obj,
          [key]: currentLine[j]
        }
      }
      // console.log(obj)

      result.push(obj);
    }
    // setImportData(result)
    return result;
  };

  const headers = [
    { label: "Name", key: "name" },
    { label: "Phone", key: "phone_number" },
    { label: "Email", key: "email" },
    { label: "Address", key: "address" }
  ];

  // const sendBulkEmails = async () => {
  //   const detailArray = Object.values(Details);

  //   await fetch("http://localhost:4000/send-bulk-email", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       emails: detailArray.map(d => d.Email),
  //       content: EmailContent,
  //       subject: EmailSubject
  //     })
  //   });

  //   alert("Emails queued successfully");
  // };


  return (
    <div>
      <div className="row">
        {/* <div className="col-1" /> */}
        <div className="form-view mb-3">
          <h4><center>Nagarpalika details</center></h4>
          {EditCourseGroup ?
            <div className="m-2">
              <div style={{ cursor: "pointer" }} onClick={() => { setEditCourseGroup(false) }}>Done Edit</div>
              {ShowCourseGroupList &&
                <div style={{ maxHeight: "50vh", overflow: "scroll", backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <table>
                    <tbody>

                      {Object.values(Details).map((item, index) => (
                        <tr key={index} style={{ display: "flex", padding: "3px 0" }}>
                          <td style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</td>
                          <td>
                            <input className="input-common-4"
                              value={item.Name} placeholder="Title"
                              onChange={(event) => {
                                var value = Details[[Object.keys(Details)[index]]]
                                value = {
                                  ...value,
                                  "Name": event.target.value
                                }
                                setDetails({
                                  ...Details,
                                  [Object.keys(Details)[index]]: value
                                })
                              }}
                            />
                          </td>
                          <td>
                            <input className="input-common-4"
                              value={item.Email} placeholder="Email"
                              onChange={(event) => {
                                var value = Details[[Object.keys(Details)[index]]]
                                value = {
                                  ...value,
                                  "Email": event.target.value
                                }
                                setDetails({
                                  ...Details,
                                  [Object.keys(Details)[index]]: value
                                })
                              }}
                            />
                          </td>
                          <td>
                            <input className="input-common-4"
                              value={item.Address} placeholder="Address"
                              onChange={(event) => {
                                var value = Details[[Object.keys(Details)[index]]]
                                value = {
                                  ...value,
                                  "Address": event.target.value
                                }
                                setDetails({
                                  ...Details,
                                  [Object.keys(Details)[index]]: value
                                })
                              }}
                            />
                          </td>
                          <td>
                            <input className="input-common-4"
                              value={item.Phone} placeholder="Address"
                              onChange={(event) => {
                                var value = Details[[Object.keys(Details)[index]]]
                                value = {
                                  ...value,
                                  "Phone": event.target.value
                                }
                                setDetails({
                                  ...Details,
                                  [Object.keys(Details)[index]]: value
                                })
                              }}
                            />
                          </td>
                          <td>
                            {Object.values(Details).filter(a => a.chapter_type == item).length == 0 &&
                              <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                                var ObjectForDelete = Details
                                var key = Object.keys(Details)[index]
                                console.log(key, Details)
                                delete ObjectForDelete[key];
                                setDetails(ObjectForDelete)
                                setShowCourseGroupList(false)
                                setTimeout(() => {
                                  setShowCourseGroupList(true)
                                }, 10)
                              }}>
                                Delete
                              </span>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              }
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    var newValue = {
                      "Name": "",
                      "Phone": "",
                      "Address": "",
                      "Email": ""
                    }
                    var lastkey = Object.keys(Details).length == 0 ? 0 : Number(Object.keys(Details)[Object.keys(Details).length - 1])
                    console.log(lastkey + 1)
                    var newKey = `${lastkey + 1}`
                    var newObject = Details;
                    newObject = {
                      ...Details,
                      [newKey]: newValue
                    }
                    console.log(newObject)

                    setDetails(newObject)
                  }}
                >
                  Add Nagarpalika
                </div>
              </div>
            </div>
            :
            <div>
              <div onClick={() => { setEditCourseGroup(true) }} style={{ cursor: "pointer", margin: "10px" }}>Edit</div>
              <div style={{ maxHeight: "50vh", overflow: "scroll", backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>

                <table>
                  <thead>
                    <tr>
                      <td>SN</td>
                      <td>Name</td>
                      <td>Email</td>
                      <td>Address</td>
                      <td>Phone Number</td>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.values(Details).map((item, index) => (
                      <tr key={index} style={{ padding: "10px ", border: "0.5px solid #999" }}>
                        {/* {item} */}
                        <td>{index + 1}</td>
                        <td>{item.Name}</td>
                        <td>{item.Email}</td>
                        <td>{item.Address}</td>
                        <td>{item.Phone}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          }
          {/* {JSON.stringify(Details)} */}
          <div className="row center m-2">
             <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  // UploadDetails()
                  // setImportData([])

                  setDetails([])

                  // SendEmail()
                }}
              >
                Clear All
              </div>
            </div>
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  // UploadDetails()
                  setImportData([])

                  setToStudentModal(true)

                  // SendEmail()
                }}
              >
                Upload details
              </div>
            </div>
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                  // SendEmail()
                }}
              >
                Update
              </div>
            </div>
          </div>
        </div>
      </div>

      <SendBulk Details={Details} />
      <div className="row d-none" >
        {/* <div className="col-1" /> */}
        <div className="form-view mb-3">
          <h4><center>Email Content</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Subject</td>
                <td className="col-6">
                  <input className="input-common"
                    value={EmailSubject} placeholder="Email Subject"
                    onChange={(event) => { setEmailSubject(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Email Content</td>
                <td className="col-6">
                  <textarea rows={7} className="input-common"
                    value={EmailContent} placeholder="Email Content"
                    onChange={(event) => { setEmailContent(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Attachment</td>
                <td className="col-6">
                  <input
                    type="file"
                    // value={EmailContent} placeholder="Email Content"
                    onChange={e => setFile(e.target.files[0])}
                  // onChange={(event) => { setEmailContent(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Include Name</td>
                <td className="col-6">
                  <CustomButtonUnSelect setData={setIncludeName} Data={IncludeName} DataValue={"Yes"} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">

            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                  var DetailArray = Object.values(Details)
                  for (let i = 0; i < DetailArray.length; i++) {
                    // if (IncludeName == "Yes") {
                    setTimeout(() => {
                      console.log(DetailArray[i])
                      SendEmail(DetailArray[i].Email,
                        `नमस्कार,<br/>${EmailContent.replaceAll("\n", "<br/>")}`)
                    }, i * 150)
                    // }
                  }
                }}
              >
                Send Email to Alla
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Email Sent to :{counter} */}
      {toStudentModel &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-2 col-1"></div>
            <div className="col-md-8 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setToStudentModal(false)
                    setImportData([])

                  }}
                >X</div>
                <div style={{ display: "none" }} >
                  <input ref={fileRefSingle}
                    type={"file"}
                    id={"csvFileInput"}
                    accept={".csv"}
                    onChange={handleOnChange}
                  />
                </div>
                <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
                  onClick={() => {
                    fileRefSingle.current.click()
                  }}
                >Import CSV</div>
                {/* {JSON.stringify(ImportData)} */}

                <div style={{ maxHeight: "50vh", overflow: "scroll", backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <table style={{ maxHeight: "50vh" }}>
                    <thead>
                      <tr>
                        <td>SN</td>
                        <td>Name</td>
                        <td>Email</td>
                        <td>Phone Number</td>
                      </tr>
                    </thead>
                    <tbody>

                      {Object.values(ImportData).map((item, index) => (

                        < tr key={index} style={{ padding: "10px ", border: "0.5px solid #999" }}>
                          {/* {item} */}
                          <td>{index + 1}</td>
                          <td>{item.Name}</td>
                          <td>{item.Email}</td>
                          <td>{item.Address}</td>
                          <td>{item.Phone}</td>
                        </tr>
                      ))}
                      {/* <TableRow row={item} index={index} /> */}
                    </tbody>
                  </table>
                </div>
                <div className="row center">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setToStudentModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        // setDetails(
                        //   concat(ImportData)
                        var newArr = Object.values(Details);
                        var newArr = newArr.concat(ImportData)
                        console.log(newArr)
                        setDetails(
                          newArr
                        )
                        setToStudentModal(false)
                      }}
                    >
                      Add All
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }


      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div >
  )

}

